<template>
  <div class="asset-package-container">
    <div class="search-form">
      <a-form layout="inline" style="margin-bottom: 26px">
        <a-form-item>
          <a-input-group compact>
            <a-select v-model="queryParam.searchType" style="width: 150px">
              <a-select-option value="id">{{ $t('investorList.zcbid') }}</a-select-option>
              <a-select-option value="assetTitle">{{ $t('investorList.zcbmc') }}</a-select-option>
            </a-select>
            <a-input
              v-model="queryParam.searchValue"
              style="width: 200px"
              :placeholder="$t('enter') + ' ' + $t('investorList.zcbmc')"
            />
          </a-input-group>
        </a-form-item>
        <a-form-item :label="$t('investorList.zcbzt')">
          <a-select v-model="queryParam.status" style="width: 200px" :placeholder="$t('all')">
            <a-select-option value="">{{ $t('investorList.qb') }}</a-select-option>
            <a-select-option value="0">{{ $t('waitingForFullBid') }}</a-select-option>
            <a-select-option value="1">{{ $t('fullBid') }}</a-select-option>
            <a-select-option value="2">{{ $t('failedBid') }}</a-select-option>
            <a-select-option value="4">{{ $t('disbursementSuccess') }}</a-select-option>
            <a-select-option value="5">{{ $t('completed') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('investorList.zcbdj')">
          <a-select v-model="queryParam.level" style="width: 120px" :placeholder="$t('all')">
            <a-select-option value="">{{ $t('investorList.qb') }}</a-select-option>
            <a-select-option value="1">A</a-select-option>
            <a-select-option value="2">B</a-select-option>
            <a-select-option value="3">C</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">{{ $t('reset') }}</a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-table
      bordered
      :columns="columns"
      :data-source="dataSource"
      :pagination="pagination"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      @change="handleTableChange"
      rowKey="investId"
    >
      <span slot="level" slot-scope="text">
        {{ levelFilter(text) }}
      </span>
      <span slot="status" slot-scope="text">
        {{ statusFilter(text) }}
      </span>
      <span slot="yieldRate" slot-scope="text"> {{ text }}% </span>
      <span slot="investAmount" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleBorrowerDetail(record)">{{ $t('investorList.jkrmx') }}</a>
        <a-divider type="vertical" />
        <a @click="handleInvestorDetail(record)">{{ $t('investorList.tzrmx') }}</a>
        <a-divider type="vertical" v-if="hasEditPermission"/>
        <a v-if="hasEditPermission" v-action:edit @click="handleEdit(record)">{{ $t('investorList.xgtzzt') }}</a>
      </span>
    </a-table>
    <borrower-detail-modal ref="borrowerDetailModal" />
    <investor-detail-modal ref="investorDetailModal" />
    <asset-package-status-modal ref="assetPackageStatusModal" @success="loadData" />
  </div>
</template>

<script>
import { getAssetPackageList, getInvestorList1 } from '@/webpublicapi/vietnamBackstage'
import { getPermissions } from '@/webpublicapi/login.js'
import { getDictList } from '@/webpublicapi/vietnamBackstage'
import BorrowerDetailModal from './modules/BorrowerDetailModal.vue'
import InvestorDetailModal from './modules/InvestorDetailModal.vue'
import AssetPackageStatusModal from './modules/AssetPackageStatusModal.vue'

export default {
  name: 'AssetPackage',
  components: { BorrowerDetailModal, InvestorDetailModal, AssetPackageStatusModal },
  data() {
    return {
      loading: false,
      hasEditPermission: false,
      queryParam: {
        searchType: 'id',
        searchValue: '',
        status: '',
        level: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('investorList.zcbid'), align: 'center', dataIndex: 'investId' },
        { title: this.$t('investorList.zcbmc'), align: 'center', dataIndex: 'investTitle' },
        {
          title: this.$t('investorList.zcbdj'),
          align: 'center',
          dataIndex: 'investLevel',
          scopedSlots: { customRender: 'level' },
        },
        {
          title: this.$t('investorList.bdje'),
          align: 'center',
          dataIndex: 'investAllAmount',
          scopedSlots: { customRender: 'investAmount' },
        },
        { title: this.$t('investorList.tzzqt'), align: 'center', dataIndex: 'investDuration' },
        {
          title: this.$t('investorList.syl'),
          align: 'center',
          dataIndex: 'investYieldRate',
          scopedSlots: { customRender: 'yieldRate' },
        },
        {
          title: this.$t('investorList.zcbzt'),
          align: 'center',
          dataIndex: 'investAssetStatus',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('investorList.zcbgc'),
          align: 'center',
          dataIndex: 'investLoanCount',
          scopedSlots: { customRender: 'investLoanCount' },
        },
        {
          title: this.$t('investorList.zcbgc1'),
          align: 'center',
          dataIndex: 'investorCount',
        },
        { title: this.$t('investorList.cz'), align: 'center', key: 'action', fixed: 'right', scopedSlots: { customRender: 'action' } },
      ]
    },
  },
  created() {
    this.loadData()
    this.getPermissions()
  },
  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.queryParam = {
        searchType: 'id',
        searchValue: '',
        status: '',
        level: '',
      }
      this.pagination.current = 1
      this.loadData()
    },
    loadData() {
      this.loading = true

      let params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      if (this.queryParam.status) {
        params.status = this.queryParam.status
      }
      if (this.queryParam.level) {
        params.level = this.queryParam.level
      }

      if (this.queryParam.searchType === 'id' && this.queryParam.searchValue) {
        params.id = Number(this.queryParam.searchValue)
      } else if (this.queryParam.searchValue) {
        params.assetTitle = this.queryParam.searchValue
      }

      getAssetPackageList(params)
        .then((res) => {
          if (res.success && res.respData) {
            const { records, total, current } = res.respData
            this.dataSource = records || []
            this.pagination.total = total || 0
            this.pagination.current = current || 1
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    levelFilter(level) {
      const map = { 1: 'A', 2: 'B', 3: 'C' }
      return map[level] || level
    },
    statusFilter(status) {
      const map = {
        0: this.$t('waitingForFullBid'),
        1: this.$t('fullBid'),
        2: this.$t('failedBid'),
        4: this.$t('disbursementSuccess'),
        5: this.$t('completed'),
      }
      return map[status] || this.$t('unknown')
    },
    handleBorrowerDetail(record) {
      this.$refs.borrowerDetailModal.show(record.investId)
    },
    handleInvestorDetail(record) {
      this.$refs.investorDetailModal.show(record.investId)
    },
    handleEdit(record) {
      this.$refs.assetPackageStatusModal.show(record)
    },
    getPermissions() {
      getPermissions().then((res) => {
        if (res.code === 1000 && res.data) {
          const hasPermission = res.data.some(
            (item) => item.key === 'com.weilu.mng.controller.InvestController@updateInvestAssetStatus'
          )
          this.hasEditPermission = hasPermission
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
